import { Section, TitleAndDescription } from '@ferreri/prever-component-lib';
import dynamic from 'next/dynamic';

import { SkeletonContractMenu } from '../../components/skeletons/SkeletonContractMenu';

const ContractMenu = dynamic(() => import('contract/contractMenu'), {
  loading: () => <SkeletonContractMenu />,
});

export const PlansSection = () => (
  <Section>
    <TitleAndDescription
      title="Planos Prever Angelus"
      description="Apoio e proteção para todo ciclo de vida"
    />

    <ContractMenu />
  </Section>
);
